import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/homePage'
import down from '@/views/downLoad'
import graph from '@/views/graphPage'
import demo from '@/views/demoPage'
import pricing from '@/views/pricingPage'
//错误页面
import errorPage from '../views/errorPage.vue';
//import repository from '@/views/repositoryPage'
import repository from '@/register/repositoryPage'
import register from '@/register/registerPage'
import usercenter from '@/vip/resetPage'

import demodetail from '@/detail/demodetail'
import repository1 from '@/detail/repositorydetail.vue'

import yonghuxieyi from '@/components/yonghuxieyi'
//import developdocument from '@/views/developdocument'
import developdocument from '@/views/tree'
import atlasdetails from '@/views/atlasdetails'
import announcementPage from '@/views/announcementPage'
import noticePage from '@/views/noticePage'
import enterPage from '@/views/enterPage'

//Henry
import correlation from '@/views/correlation'

Vue.use(Router)

const routes = [
	{
      path: '/',
      name: 'home',
      component: home,
			meta: {
				keepAlive: false // 需要被缓存
			}
    },
     {
      path: '/down',
      name: 'down',
      component: down,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
     {
      path: '/graph',
      name: 'graph',
      component: graph,
			meta: {
				keepAlive: false // 需要被缓存
			}
    },
     {
      path: '/demo',
      name: 'demo',
      component: demo,
			meta: {
				keepAlive: false // 需要被缓存
			}
    },
     {
      path: '/pricing',
      name: 'pricing',
      component: pricing,
			meta: {
				keepAlive: false // 需要被缓存
			}
    },
    {
      path: '/repository',
      name: 'repository',
      component: repository,
			meta: {
				keepAlive: true // 需要被缓存
			}
    },
    {
      path: '/repository1',
      name: 'repository1',
      component: repository1,
			meta: {
				keepAlive: false
			}
    },
    {
      path: '/yonghuxieyi',
      name: 'yonghuxieyi',
      component: yonghuxieyi,
      meta: {
				keepAlive: false
			}
    },
    {
     path: '/usercenter',
      name: 'usercenter',
      component: usercenter,
			meta: {
				keepAlive: false
			}
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
    	path:'/demodetail',
    	name:'demodetail',
    	component:demodetail,
			meta: {
				keepAlive: false
			}
    },
     {
    	path:'/developdocument',
    	name:'developdocument',
    	component:developdocument,
      meta: {
        keepAlive: false
      }
    },
    {
    	path:'/atlasdetails',
    	name:'atlasdetails',
    	component:atlasdetails,
			meta: {
				keepAlive: false
			}
    },
    {
    	path:'/announcementPage',
    	name:'announcementPage',
    	component:announcementPage
    },
    {
    	path:'/noticePage',
    	name:'noticePage',
    	component:noticePage
    },
    {
    	path:'/enterPage',
    	name:'enterPage',
    	component:enterPage
    },
		{
			path:'/correlation',
			name:'correlation',
			component:correlation
		},
	{
    path: '/404',
    name: 'error',
    component: errorPage,
},
{
    path: '*',
    redirect: '/404',
},	
    
];
export default new Router({
//	 mode: 'history',
	routes,
	scrollBehavior (to, from, savedPosition) {
 if (savedPosition) {
  return savedPosition
 } else {
  return { x: 0, y: 0 }
 }
 }
})



// WEBPACK FOOTER //
// ./src/router/index.js